import { memo } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

function FundingIdForm({ fundingId }) {
  return (
    <>
      <Col md={2} className="bo-same-line">
        <Form.Label>Advance ID:</Form.Label>
      </Col>
      <Col md={4} className="bo-same-line">
        <Form.Control
          className="bo-input"
          type="text"
          name="id"
          id="id"
          value={fundingId.toString().padStart(6, '0')}
          readOnly
        />
      </Col>
    </>
  );
}

export default memo(FundingIdForm);
